import { click, select, type, wait, withTab } from './helpers'
import type { DemoAction } from '@guideguide/shared/src/demo/types'

const sequenceThreeColumn = withTab('tabGrid', [
  wait('move-between'),
  type('marginTop', '40px'),
  wait('move-between'),
  type('marginBottom', '40px'),
  wait('move-between'),
  type('marginLeft', '40px'),
  wait('move-between'),
  type('marginRight', '40px'),
  wait('move-between'),
  wait('move-between'),
  type('columnCount', '3'),
  wait('move-between'),
  type('columnGutter', '20px | 20px'),
  wait('move-between'),
  click('addGuides'),
  wait('hold-to-process'),
  click('clearGuides'),
  wait('move-between'),
  click('resetForm'),
])

const sequenceCrosshairs = withTab('tabGrid', [
  select(({ width, height }) => {
    const size = 200
    return {
      x: (width - size) / 2,
      y: (height - size) / 2,
      width: size,
      height: size,
    }
  }),
  wait(1000),
  click('addGuides'),
  wait('move-between'),
  click('quickCenter'),
  wait('move-between'),
  click('quickMiddle'),
  wait('hold-to-process'),
  select(null),
  click('clearGuides'),
])

const sequenceBaseline = withTab('tabCustom', [
  type(
    'notation',
    '# Baseline grid\n$row = | 16px |\n\n# Repeat while there is space\n$row* (hfp)'
  ),
  wait('move-between'),
  click('addGuides'),
  wait('hold-to-process'),
  type('notation', ''),
  click('clearGuides'),
])

const sequenceFibonacci = withTab('tabSaved', [
  click('lastGrid'),
  wait('move-between'),
  click('addGuides'),
  wait('hold-to-process'),
  click('lastGrid'),
  wait('move-between'),
  click('clearGuides'),
])

const script: DemoAction[] = [
  wait('hold-to-process'),
  ...sequenceThreeColumn,
  wait('hold-to-process'),
  ...sequenceCrosshairs,
  wait('hold-to-process'),
  ...sequenceBaseline,
  wait('hold-to-process'),
  ...sequenceFibonacci,
]

export default script
